<template>
  <button
    :data-bs-target="`#revokeModal${purchase.id}`"
    class="btn btn-danger text-white"
    data-bs-toggle="modal"
    type="button"
  >
    {{ $t("membershipPage.revoke") }}
  </button>

  <div
    :id="`revokeModal${purchase.id}`"
    :aria-labelledby="`revokeModal${purchase.id}Label`"
    aria-hidden="true"
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 :id="`revokeModal${purchase.id}Label`" class="modal-title">
            Bestellung widerrufen
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            type="button"
          ></button>
        </div>

        <div class="modal-body">
          <p>
            Mit dem Widerrufen der Bestellung wird die Mitgliedschaft um
            {{ purchase.period }} Tage verkürzt.
          </p>

          <p
            v-if="remainingDays - purchase.period === 0"
            class="alert alert-danger mb-0"
          >
            Nach dem Widerruf ist die Mitgliedschaft ausgelaufen und es ist kein
            Zugriff mehr auf die App möglich.
          </p>

          <p
            v-else-if="remainingDays - purchase.period < 10"
            class="alert alert-danger mb-0"
          >
            Nach dem Widerruf verbleiben nur noch
            {{ remainingDays - purchase.period }} Tage.
          </p>

          <p v-else class="mb-0">
            Nach dem Widerruf verbleiben noch
            {{ remainingDays - purchase.period }} Tage.
          </p>
        </div>

        <div class="modal-footer">
          <button
            :disabled="loading"
            class="btn btn-danger text-white w-100"
            type="button"
            @click.prevent="revokePurchase"
          >
            Bestellung widerrufen
          </button>

          <button
            :disabled="loading"
            class="btn btn-light w-100"
            data-bs-dismiss="modal"
            type="button"
            @click.prevent="cancel"
          >
            Abbrechen
          </button>

          <div v-if="error" class="alert alert-danger mt-4 w-100">
            {{ errorText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapGetters } from "vuex";
export default {
  name: "RevokePurchase",
  props: {
    purchase: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modal: null,
      loading: false,
      error: false,
      errorText: null,
    };
  },
  computed: {
    ...mapGetters({
      remainingDays: "membership/getRemainingDays",
    }),
  },
  methods: {
    cancel() {
      this.error = false;
      this.errorText = null;
    },
    async revokePurchase() {
      const _this = this;

      this.loading = true;
      this.error = false;
      this.errorText = null;

      await this.modal.hide();

      await this.$store
        .dispatch("membership/revokePurchase", this.purchase.id)
        .then(() => {
          _this.loading = false;
        })
        .catch((error) => {
          _this.loading = false;
          this.errorText = this.globalErrorText(error);
          this.error = true;
          _this.modal.show();
        });
    },
  },
  mounted() {
    this.modal = new Modal(
      document.getElementById(`revokeModal${this.purchase.id}`)
    );
  },
};
</script>

<style scoped></style>
